import ToastClass from "@/utils/toast/toastClass";

function Toast() {
  const toastInToastComponent = new ToastClass();
  return (
    <div
      id="saber-toast-01"
      className="fixed toast-style-main-component-out bottom-[7.5%] right-[5%] min-w-[15%] max-w-[25%] min-h-[8vh] max-h-[14vh] flex flex-wrap items-center justify-between bg-[#ddd] p-[10px] rounded-[4px] border-[1px] border-[#eee] z-[100] "
      style={{
        boxShadow:
          "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
      }}
    >
      <div className="right">
        <button
          onClick={() => toastInToastComponent.closeImmediate()}
          className="text-[#]"
        >
          &#10006;
        </button>
      </div>
      <div
        id="saber-toast-01-middle"
        className="middle gap-[8px] flex items-center justify-center mx-[2rem]"
      >
        {/* <span className="text-[green] text-[20px] ">&#x2713;</span>
        <h2 id="saber-toast-01-message" className="text-[#555] text-[18px] ">
          Done!
        </h2>*/}
      </div>
      <div className="left"></div>
    </div>
  );
}

export default Toast;
